import React from 'react';

const Footer = () => (
  <footer className="footer-wrapper" data-testid="footer">
    <div className="footer-content">
      <p className="copyright-text">Created with mathematical inspirations</p>
    </div>
  </footer>
);

export default Footer;
